"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ClearIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 15V0v15zM15 0v15V0zM8.349 7.5l5.222 5.222c.195.195.195.512 0 .707l-.142.142c-.195.195-.512.195-.707 0L7.5 8.349l-5.222 5.222c-.195.195-.512.195-.707 0l-.142-.142c-.195-.195-.195-.512 0-.707L6.651 7.5 1.429 2.278c-.195-.195-.195-.512 0-.707l.142-.142c.195-.195.512-.195.707 0L7.5 6.651l5.222-5.222c.195-.195.512-.195.707 0l.142.142c.195.195.195.512 0 .707L8.349 7.5z",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 20V0m20 0v20M16.177 4.884L11.061 10l5.116 5.116c.195.195.195.512 0 .707l-.354.354c-.195.195-.512.195-.707 0L10 11.061l-5.116 5.116c-.195.195-.512.195-.707 0l-.354-.354c-.195-.195-.195-.512 0-.707L8.939 10 3.823 4.884c-.195-.195-.195-.512 0-.707l.354-.354c.195-.195.512-.195.707 0L10 8.939l5.116-5.116c.195-.195.512-.195.707 0l.354.354c.195.195.195.512 0 .707",
  fillRule: "evenodd"
});

function ClearIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: function viewBox(size) {
      return size < 20 ? '0 0 15 15' : '0 0 20 20';
    }
  }, props), function (size) {
    return size < 20 ? _ref : _ref2;
  });
}

ClearIcon.displayName = 'ClearIcon';